<template lang="">
    <div class="position-re setting_project-owner" :style="{width: width, height: width}">
        <template v-if="!data.type || data.type === 'user'">
            <!-- PROFILE -->
            <template v-if="data.image">
                 <img v-if="data.image?.includes('http')" @error="onImgError" :title="displayTitle" class="profile-image asignee-profile" :class="{ 'border-red': isBorder }" :src="imgSrc" alt="" :style="{width: width, height: width}"/>
                 <WasabiImage 
                    v-else :userImage="true"
                    :style="{width: width, height: width}" 
                    class="profile-image asignee-profile" 
                    :data="{title: displayTitle, url: data?.image, filename: data?.image?.split('/').pop(), extension: data.image?.split('/').pop().split('.').pop()}" :thumbnail="thumbnail"/>
             </template>
             <template v-else>
                <img :title="displayTitle"
                class="profile-image asignee-profile"
                :class="{ 'border-red': isBorder }"
                :src="defaultUserAvatar" 
                alt="" 
                :style="{width: width, height: width}" />
             </template>
            <!-- <img :src="data.image" alt="user image" class="profile-image asignee-profile" :title="data.title ? data.title : 'N/A'" :style="{width: width, height: width, verticalAlign: 'middle'}"/> -->
            <!-- STATUS -->
            <span
                v-if="showDot"
                class="user-status"
                :class="{ online: isOnline }"
                :title="isOnline ? $t('Common.online') : $t('Common.offline')"
                role="status"
            ></span>
        </template>

        <template v-if="data.type && data.type === 'team'">
            <div class="cursor-pointer text-center profile-image font-size-15" :title="data.title ? data.title : 'N/A'" :style="[{'color': data?.teamColor?.color,'background-color': data?.teamColor?.bgColor, 'padding':'5px', width: width, height: width}]">{{data.title ? data.title.charAt(0): data.label.charAt(0)}}</div>
        </template>
    </div>
</template>
<script setup>
import { computed, defineProps, inject, ref, watch } from "vue";
import { useStore } from "vuex";
import WasabiImage from "@/components/atom/WasabiIamgeCompp/WasabiIamgeCompp.vue";

const defaultUserAvatar = inject("$defaultUserAvatar");
const { getters } = useStore();

const props = defineProps({
  data: {
    type: Object,
    default: () => ({})
  },
  showDot: {
    type: Boolean,
    default: true
  },
  width: {
    type: String,
    default: "50px"
  },
  thumbnail: {
    type: String
  },
  isBorder: {
    type: Boolean,
    default: false
  }
});

const imgSrc = ref(defaultUserAvatar);
const userId = computed(() => props.data?.id || props.data?._id || props.data?.userId || props.data?.key || props.data?.value || props.data?.uid || props.data?.UserId || "");
const storeUser = computed(() => {
  if (!userId.value) return null;
  return getters["users/users"]?.find((user) => user._id === userId.value || user.id === userId.value) || null;
});
const companyUser = computed(() => {
  if (!userId.value) return null;
  return getters["settings/companyUsers"]?.find((user) => user.userId === userId.value || user._id === userId.value) || null;
});
const displayTitle = computed(() => {
  const nicknames = getters["settings/companyUserDetail"]?.nicknames || {};
  return String(nicknames?.[userId.value] || '').trim()
    || props.data?.title
    || storeUser.value?.Employee_Name
    || "N/A";
});
const isOnline = computed(() => {
  if (typeof storeUser.value?.isOnline === "boolean") return storeUser.value.isOnline;
  if (typeof companyUser.value?.isOnline === "boolean") return companyUser.value.isOnline;
  return Boolean(props.data?.isOnline);
});

// sync src khi data.image đổi
watch(
  () => props.data?.image,
  (val) => {
    imgSrc.value = val || defaultUserAvatar;
  },
  { immediate: true }
);

function onImgError(e) {
  e.target.onerror = null; // tránh loop
  imgSrc.value = defaultUserAvatar;
}
</script>

<style>
@import "./style.css";
</style>
